import React, { Component, Fragment } from "react";
import { matchPath } from "react-router";
import api from "services/api";

import { connect } from "react-redux";

import { withTranslation } from "react-i18next";
import { compose } from "recompose";

import { Page, Form, Loading } from "components";

class East extends Component {
  state = {
    confirmed: false,
    journey: {},
    quiz: [],
    loading: true,
    page: 1,
    total: 1,
    answering: false,
    initializated: false
  };

  async componentDidMount() {
    await localStorage.setItem("east_face_initializated", true);
    this.loadInterview();
  }

  loadInterview = async () => {
    const { history } = this.props;

    const response = await api.get(`search/interviews/${this.handleGetID()}`);
    const { data } = response.data;

    const type = data.attributes.interviewable_type;
    const IS_EAST = "EastFace::Quiz";

    const face =
      type === IS_EAST
        ? data.attributes.interviewable
        : data.attributes.interviewable.east_face_quiz;

    if (face.current_question === 0) {
      history.push(
        `/journey/${this.handleGetID()}/${
          type === IS_EAST ? "complete" : "north"
        }`
      );
      return;
    } else if (face.current_question === 1) {
      await localStorage.setItem("east_face_initializated", false);
    }

    const initializated = await JSON.parse(
      localStorage.getItem("east_face_initializated")
    );
    this.setState({ initializated });

    const page = Math.ceil(face.current_question / 6);
    const total = Math.ceil(face.total_questions / 6);

    this.setState({ journey: face, page, total });
    this.loadQuiz(face);
  };

  loadQuiz = async face => {
    const { page } = this.state;
    const response = await api.get(
      `east_face/quizzes/${face.id}/questions/page?page=${page}&per=6`
    );
    const { data } = response.data;

    const quiz = data;

    this.setState({
      quiz: quiz.map(quiz => ({
        ...quiz,
        attributes: {
          ...quiz.attributes,
          question: {
            ...quiz.attributes.question
          }
        },
        value: 0
      })),
      loading: false,
      answering: false
    });
  };

  handleGetID = () => {
    const { location } = this.props;
    const match = matchPath(location.pathname, { path: "/journey/:id/east" });
    return match.params.id;
  };

  handleChangeAlternative = (id, value) => {
    const { quiz } = this.state;

    const index = quiz.map(quiz => quiz.id).indexOf(id);
    quiz[index].value = value;

    this.setState({
      quiz
    });
  };

  handleConfirm = () => {
    const { confirmed } = this.state;

    this.setState({ confirmed: !confirmed });
  };

  handleAnswer = async () => {
    const { quiz } = this.state;
    const { user, t } = this.props;

    const answers = quiz.filter(quiz => quiz.value !== 0);

    if (answers.length < quiz.length) {
      alert(t("Você precisa preencher toda as questões!"));
      return;
    }

    this.setState({ answering: true });

    await api.post(`east_face/quizzes/quizquestion/respond`, {
      interview_id: this.handleGetID(),
      person_id: user.data.id,
      quiz_questions: quiz
    });

    this.setState({ confirmed: false });

    await this.loadInterview();
  };

  handleInitialize = async () => {
    await localStorage.setItem("east_face_initializated", true);
    this.setState({ initializated: true });
  };

  render() {
    const {
      confirmed,
      journey,
      quiz,
      loading,
      page,
      total,
      answering,
      initializated
    } = this.state;
    const { t } = this.props;

    return (
      <Page className="journey">
        {!loading && (
          <Fragment>
            {!initializated ? (
              <div className="text-center">
                <div className="header">
                  <div className="title">
                    <span className="face">{journey.instructions_content}</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      className="button-submit"
                      onClick={this.handleInitialize}
                    >
                      {t("Iniciar Questionário")}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Fragment>
                <div className="header">
                  <span className="step">{`${page}/${total}`}</span>
                  <div className="title">
                    <span className="face">{t("Face Leste")}</span>
                    <span className="question">
                      {t(
                        "É importante que você trabalhe sem pressa e responda a todas as afirmações sinceramente."
                      )}
                    </span>
                  </div>
                </div>

                <div className="questions">
                  <div className="options">
                    <span>
                      {t("Absolutamente não me identifico com a frase")}
                    </span>
                    <span>{t("Descreve-me perfeitamente")}</span>
                  </div>

                  {quiz.map((quiz, index) => (
                    <div className="question" key={quiz.id}>
                      <div className="question-title">
                        <span className="question-label">
                          {quiz.attributes.question_order}
                        </span>
                        <span className="question-name">
                          {quiz.attributes.question.title}
                        </span>
                      </div>

                      <div className="question-options">
                        {Array.from({ length: journey.points }).map(
                          (value, index) => (
                            <div className="question-option-radio" key={index}>
                              <span>{index + 1}</span>
                              <Form.Radio
                                checked={quiz.value === index + 1}
                                onChange={() =>
                                  this.handleChangeAlternative(
                                    quiz.id,
                                    index + 1
                                  )
                                }
                              />
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="buttons">
                  <button
                    type="button"
                    disabled={!confirmed || answering}
                    className="button-submit"
                    onClick={this.handleAnswer}
                  >
                    {answering ? (
                      <Loading size="xs" text={t("Respondendo...")} />
                    ) : (
                      t("Próxima Questão")
                    )}
                  </button>

                  <Form.Checkbox
                    label={t("Confirmar Resposta")}
                    checked={confirmed}
                    onChange={this.handleConfirm}
                  />
                </div>
              </Fragment>
            )}
          </Fragment>
        )}
      </Page>
    );
  }
}

const mapState = state => ({
  user: state.auth.user
});

export default compose(connect(mapState), withTranslation())(East);



// WEBPACK FOOTER //
// ./src/pages/Journey/East/index.js